import React from 'react';
import {PropTypes} from 'prop-types';
import {PropTypesEx} from '../../shared/proptypes.extensions';
import {Link} from '../../shared/link';
import {SimpleTooltip} from '../../shared/tooltip';
import {NormalizeClassNameString, ObjectHasProperty} from  '../../shared/utils';
import {UrlBuilder} from '../../app.defs';

export class AccountComponent extends React.Component {

    render() {
        const self = this;
        const {showId, showLoginAs, linkToInfo, id, name, disabled, usePOST, className, url} = self.props;

        const u = (typeof url === 'string') ? encodeURI(url) : undefined;

        let link = null;
        let loginAsTooltip = null;

        if (showLoginAs) {
            link = usePOST
                ?                                   
                    <Link 
                        className="loginas" 
                        to={Link.void} 
                        data-id={id} 
                        data-url={u} 
                        disabled={disabled}
                    >
                        <span className="fa fa-sign-in" />
                    </Link>
                :
                    <Link 
                        to={UrlBuilder.LoginAs({AccountId: id, Url: u})} 
                        disabled={disabled}
                    >
                        <span className="fa fa-sign-in" />
                    </Link>

            loginAsTooltip = {
                title: `LogIn as ${name}`,
                placement: 'right',
                ...self.props.loginAsTooltip
            };

            if (ObjectHasProperty(loginAsTooltip, 'visible')) {
                loginAsTooltip.visible = Boolean(loginAsTooltip.visible) && !disabled;
            }
            else {
                loginAsTooltip.visible = !disabled;
            }
        }

        return (
            <span className={NormalizeClassNameString((className || '') + ' d-flex text-truncate')}>
                {Boolean(showId) && <span className="mre-2">{id}</span>}
                <span className="mre-2 text-truncate">
                    {!linkToInfo && name}
                    {linkToInfo && <Link to={UrlBuilder.AccountInfo({AccountId: id})} disabled={disabled}>{name}</Link>}
                </span>
                {Boolean(link) &&
                    <SimpleTooltip {...loginAsTooltip}>
                        {link}
                    </SimpleTooltip>
                }
            </span>
        )
    }
}
AccountComponent.propTypes = {
    id: PropTypesEx.integer.isStringAllowed.isRequired,
    name: PropTypes.string.isRequired,
    showId: PropTypes.bool,
    showLoginAs: PropTypes.bool,
    linkToInfo: PropTypes.bool,
    disabled: PropTypes.bool,
    usePOST: PropTypes.bool,
    className: PropTypes.string,
    url: PropTypes.string,
}
AccountComponent.defaultProps = {
    showId: false,
    showLoginAs: false,
    linkToInfo: false,
    usePOST: false,
    className: '',
}
